import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesCambioDePagador() {
  return (
    <ClipperPlaceholder title="Cambio de Pagador" category="Novedades" />
  );
}
